import { useCrmTagAppSettingFieldValue } from '../../frameworkAppSettings/hooks/useCrmTagAppSettingFieldValue';
import { useHasObjectTags } from './useHasObjectTags';
export const useTagPropertyName = () => {
  const hasObjectTags = useHasObjectTags();
  const propertyName = useCrmTagAppSettingFieldValue('propertyName') || undefined;
  if (hasObjectTags) {
    return propertyName;
  }
  return undefined;
};